import { Button, Container, Heading } from "@gui/components";
import * as sharedStyles from "../css/Shared.module.css";
const Settings = props => {
    const goBack = () => {
        props.onGoBack();
    };
    return (<Container>
            <Heading class={sharedStyles.shared_heading}>Settings</Heading>
            <Button name="back" onClick={goBack}>
                Back
            </Button>
        </Container>);
};
export { Settings };
